import { render, staticRenderFns } from "./NossosPilares.vue?vue&type=template&id=67e94406&scoped=true&lang=pug"
import script from "./NossosPilares.vue?vue&type=script&lang=js"
export * from "./NossosPilares.vue?vue&type=script&lang=js"
import style0 from "./NossosPilares.vue?vue&type=style&index=0&id=67e94406&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e94406",
  null
  
)

export default component.exports